var React = require('react');

function BurgerMenu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.2188 9.21875H0.78125C0.349766 9.21875 0 9.56852 0 10C0 10.4315 0.349766 10.7812 0.78125 10.7812H19.2188C19.6502 10.7812 20 10.4315 20 10C20 9.56852 19.6502 9.21875 19.2188 9.21875Z","fill":"white","key":0}),React.createElement("path",{"d":"M19.2188 2.96875H0.78125C0.349766 2.96875 0 3.31852 0 3.75C0 4.18148 0.349766 4.53125 0.78125 4.53125H19.2188C19.6502 4.53125 20 4.18148 20 3.75C20 3.31852 19.6502 2.96875 19.2188 2.96875Z","fill":"white","key":1}),React.createElement("path",{"d":"M19.2188 15.4688H0.78125C0.349766 15.4688 0 15.8185 0 16.25C0 16.6815 0.349766 17.0312 0.78125 17.0312H19.2188C19.6502 17.0312 20 16.6815 20 16.25C20 15.8185 19.6502 15.4688 19.2188 15.4688Z","fill":"white","key":2})]);
}

BurgerMenu.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = BurgerMenu;

BurgerMenu.default = BurgerMenu;
